import { render } from "./HomePageFour.vue?vue&type=template&id=c3a82436"
import script from "./HomePageFour.vue?vue&type=script&lang=js"
export * from "./HomePageFour.vue?vue&type=script&lang=js"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__